module.exports = __webpack_public_path__ + "static/tantas-cosas-son-todavia-posibles-da9af03e7641cdb59e3e331c3cd809dc.svg";